import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=18d5b339&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18d5b339"]])

export default __exports__